var React = require('react');

function IconChat (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M7.3 30.8c.1.1.3.1.5.1.3 0 .6-.1.8-.3l6.5-6.2h12.2c2.7 0 4.8-2.2 4.8-4.8V5.9c0-2.7-2.2-4.8-4.8-4.8H4.8C2.2 1.1 0 3.3 0 5.9v13.6c0 2.7 2.2 4.8 4.8 4.8h1.7v5.3c0 .6.3 1 .8 1.2zm-2.5-8.7c-1.4 0-2.5-1.1-2.5-2.5V5.9c0-1.4 1.1-2.5 2.5-2.5h22.3c1.4 0 2.5 1.1 2.5 2.5v13.6c0 1.4-1.1 2.5-2.5 2.5H14.5c-.3 0-.6.1-.8.3L8.9 27v-3.8c0-.6-.5-1.2-1.1-1.2l-3 .1z","key":0}),React.createElement("path",{"fill":"#fff","d":"M7.4 10.8H24c.6 0 1.2-.5 1.2-1.1 0-.6-.5-1.2-1.1-1.2H7.4c-.7 0-1.2.5-1.2 1.2-.1.6.4 1.1 1.2 1.1-.1 0-.1 0 0 0zM25.2 16c0-.6-.5-1.2-1.2-1.2H7.4c-.6 0-1.2.5-1.2 1.1 0 .6.5 1.2 1.1 1.2H24c.7.1 1.2-.5 1.2-1.1z","key":1})]);
}

IconChat.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = IconChat;

IconChat.default = IconChat;
